__turbopack_context__.v({
  "className": "noto_sans_jp_8a6b1131-module__SrQX_q__className",
  "variable": "noto_sans_jp_8a6b1131-module__SrQX_q__variable",
});
